<template>
    <table
        class="fm-enquete"
        style="border-style: none"
        :cellpadding="settingDesign?.table_settings?.cell_setting?.margin?.value || 0"
        :cellspacing="settingDesign?.table_settings?.cell_setting?.spacing?.value || 0"
    >
        <template v-if="lotteryBlocks.length > 0">
            <template v-for="(block, idx) in lotteryBlocks">
                <CommonBlockText
                    :key="`preview-${idx}`"
                    v-if="[ALL_BLOCK_TYPE.BLOCK_DISPLAY_1].includes(block.block_type)"
                    :index.sync="indexCommonOption"
                    :inforBlock="onHandleBlockWinning(block)"
                    :provinceInfor="inforProvince"
                    :settingDesign="settingDesign"
                    :configBlock="configBlockForm"
                    :conditionPageShow="typePageShow"
                    :pagePreview="true"
                    @getAddress="handleGetAddress"
                    :settingRequireLabel="settingRequireLabel"
                    :settingConfirmLabel="settingConfirmLabel"
                />
            </template>
        </template>
        <tbody>
            <tr v-if="winningData.prize_type === TYPE_PRIZE[0].id">
                <td class="fm-enquete-commands" style="text-align: center">
                    <div class="d-flex justify-content-center" style="gap: 12px">
                        <div v-if="winningData?.setting_buttons" class="btn__next">
                            <button
                                v-if="!winningData.setting_buttons.img_btn_register?.id"
                                class="btn form__btn-secondary text-nowrap"
                                @click="onHandleFormGift"
                            >
                                {{ winningData.setting_buttons.label_btn_register }}
                            </button>
                            <div v-else class="btn_frame_img" @click="onHandleFormGift" style="cursor: pointer">
                                <b-img
                                    :src="winningData.setting_buttons.img_btn_register.path"
                                    :alt="winningData.setting_buttons.img_btn_register.origin_name"
                                ></b-img>
                            </div>
                        </div>
                        <div v-else class="btn__next">
                            <button class="btn form__btn-secondary text-nowrap" @click="onHandleFormGift">賞品受取フォームへ</button>
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import CommonBlockText from '../common-text.vue';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { buildHeaders, TYPE_PRIZE } from '@/views/pages/phase2/manager-form/components/prize-serial-code/constants';

export default {
    name: 'FormBSeriaWinning',
    components: {
        CommonBlockText
    },
    props: {
        // Used by IframComponent (direct page data)
        inforDataWinning: {
            type: Object,
            default: () => null
        },
        // Used by preview with prize list
        listInforPrize: {
            type: Array,
            default: () => []
        },
        handleType: {
            type: String,
            default: 'use'
        },
        formInit: {
            type: Object,
            default: () => ({})
        },
        settingDesign: {
            type: Object,
            default: () => ({})
        },
        configBlockForm: {
            type: Object,
            default: () => ({})
        },
        inforProvince: {
            type: Object,
            default: () => null
        },
        typePageShow: {
            type: String,
            default: ''
        },
        settingRequireLabel: {
            type: Object,
            default: () => null
        },
        settingConfirmLabel: {
            type: Object,
            default: () => null
        },
        indexCommonOption: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            TYPE_PRIZE
        };
    },
    watch: {
        indexCommonOption(val) {
            this.$emit('update:indexCommonOption', val);
        }
    },
    computed: {
        winningData() {
            // If inforDataWinning is directly provided (IframComponent path), use it
            if (this.inforDataWinning) return this.inforDataWinning;
            // Otherwise find from listInforPrize (old path)
            return (this.listInforPrize || []).find((item) => item.id == this.formInit?.serial_prize);
        },
        lotteryBlocks() {
            return (this.winningData?.blocks || []).filter((b) => b.is_lottery || b.extension?.is_lottery);
        }
    },
    methods: {
        onHandleFormGift() {
            if (this.handleType === 'edit') return;
            window.open(`/manager-form/preview?id=${this.$route.query.id}&type=a`, '_self');
        },

        onHandleBlockWinning(block) {
            block.label = this.mapContentToString(
                block.label,
                this.winningData?.list_product_import?.length > 0 ? this.winningData?.list_product_import[0] : []
            );
            return block;
        },

        mapContentToString(template, data) {
            if (!template) return '';
            if (!data || Array.isArray(data)) return template.replace(/\{\$(\d+)\}/g, '');
            const headers = buildHeaders([data]);
            const indexMap = new Map();
            indexMap.set(1, data.code || '');
            headers.forEach((header) => {
                const match = header.label.match(/\{\$(\d+)\}/);
                if (match) {
                    const idx = parseInt(match[1]);
                    if (idx !== 1) {
                        const label = header.label.replace(/\{\$.*?\}\s*=\s*/g, '').trim();
                        indexMap.set(idx, label);
                    }
                }
            });
            const contentMap = new Map();
            if (data.contents) {
                data.contents.forEach((c) => {
                    if (c?.label != null) {
                        contentMap.set(String(c.label).trim(), c.content || '');
                    }
                });
            }
            return template.replace(/\{\$(\d+)\}/g, (match, index) => {
                const colIndex = parseInt(index);
                if (colIndex === 1) return indexMap.get(1);
                const label = indexMap.get(colIndex);
                if (label) {
                    return contentMap.get(label) || '';
                }
                return '';
            });
        },

        handleGetAddress(data) {
            this.$emit('getAddress', data);
        }
    },
    mounted() {
        window.addEventListener('resize', this.resize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resize);
    }
};
</script>

<style lang="scss" scoped></style>
